define("preview-grid/controllers/application", ["exports", "@ember/controller", "@ember/debug", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "ember-concurrency", "nprogress", "tracked-built-ins", "shared/utils/retry"], function (_exports, _controller, _debug, _object, _computed, _service, _utils, _emberConcurrency, _nprogress, _trackedBuiltIns, _retry) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/debug",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"ember-concurrency",0,"nprogress",0,"tracked-built-ins",0,"shared/utils/retry"eaimeta@70e063a35619d71f
  var _default = _exports.default = _controller.default.extend({
    auth: (0, _service.inject)(),
    alerts: (0, _service.inject)(),
    errors: (0, _service.inject)(),
    intl: (0, _service.inject)(),
    schedule: (0, _service.inject)(),
    segment: (0, _service.inject)(),
    store: (0, _service.inject)(),
    selectedSocialProfiles: (0, _service.inject)(),
    mediaLibrary: (0, _service.inject)(),
    subscriptions: (0, _service.inject)(),
    loadNumber: 0,
    isSaving: false,
    extraDisplayedScheduledPosts: 0,
    queueOrderAsc: ['queueOrder:asc'],
    newPreviewPosts: new _trackedBuiltIns.TrackedArray([]),
    scheduledTimeAsc: ['scheduledTime:asc'],
    hasSharePlanError: null,
    isDragging: (0, _computed.readOnly)('schedule.isDragging'),
    sideLibraryBehavior: (0, _computed.readOnly)('schedule.sideLibraryBehavior'),
    editedPosts: (0, _computed.filterBy)('previewPosts', 'hasBeenEdited'),
    editablePosts: (0, _computed.filterBy)('previewPosts', 'canEdit'),
    hasEditedPosts: (0, _computed.gt)('editedPosts.length', 0),
    maxQueueOrder: (0, _computed.max)('previewPostQueueOrders'),
    previewPostQueueOrders: (0, _computed.mapBy)('previewPosts', 'queueOrder'),
    sortedEditablePosts: (0, _computed.sort)('editablePosts', 'queueOrderAsc'),
    sortedExistingPosts: (0, _computed.sort)('activePosts', 'scheduledTimeAsc'),
    errorMessage: (0, _object.computed)('hasSharePlanError', function () {
      return this.hasSharePlanError ? this.intl.t('alerts.preview_grid.share_calendar.something_went_wrong') : null;
    }),
    get enableAutoSchedule() {
      if (this.get('isViewingMultiple') || (0, _utils.isNone)(this.get('sideLibraryBehavior'))) {
        return false;
      }
      return this.hasTimeSlots && this.socialProfile?.hasPublishingMethod;
    },
    get hasTimeSlots() {
      return this.get('socialProfile')?.get('hasUserTimeSlots');
    },
    get socialProfilesSelectedForScheduling() {
      return this.selectedSocialProfiles.profiles.map(profile => profile.accountType);
    },
    isViewingMultiple: (0, _object.computed)('selectedSocialProfiles.hasMultipleSelected', function () {
      return this.selectedSocialProfiles?.hasMultipleSelected;
    }),
    selectedAssets: (0, _object.computed)('mediaLibrary.selectedMedia', function () {
      return this.mediaLibrary.selectedMedia;
    }),
    activePosts: (0, _object.computed)('posts.@each.{scheduledInFuture,active,isDeleted,isInstagramStory,isInstagramReel}', 'socialProfile.id', function () {
      const posts = this.posts.filter(post => post.scheduledInFuture && post.active && !post.isDeleted && this.get('socialProfile.id') === post.belongsTo('socialProfile').id() && !post.isInstagramStory);
      return posts;
    }),
    limitedSortedExistingPosts: (0, _object.computed)('sortedExistingPosts.[]', 'numDisplayScheduledPosts', function () {
      return this.sortedExistingPosts.slice(0, this.numDisplayScheduledPosts);
    }),
    numDisplayScheduledPosts: (0, _object.computed)('postLimit', 'extraDisplayedScheduledPosts', function () {
      let numPostsLimit = this.postLimit + this.extraDisplayedScheduledPosts;
      if (numPostsLimit < this.postLimit) {
        numPostsLimit = this.postLimit;
      }
      return numPostsLimit;
    }),
    lastPreviewPostScheduledTime: (0, _object.computed)('previewPosts.@each.scheduledTime', function () {
      if (this.get('previewPosts.length') === 0) {
        return null;
      }
      let last = 0;
      this.previewPosts.forEach(item => {
        if (last < item.get('scheduledTime') && !item.get('isIgPost')) {
          last = item.get('scheduledTime');
        }
      });
      if (last === 0) {
        return null;
      }
      return last;
    }),
    // don't depend on limitedSortedExistingPosts to guard against double deletes
    // load number triggers reloads as needed
    existingPreviewPosts: (0, _object.computed)('loadNumber', 'limitedSortedExistingPosts', function () {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      let count = 0;
      this.limitedSortedExistingPosts.forEach(item => {
        const pp = item.igPreviewPost();
        pp.set('originalQueueOrder', count);
        pp.set('queueOrder', count);
        previewPosts.pushObject(pp);
        count = count + 1;
      });
      return previewPosts;
    }),
    igPostPreviewPosts: (0, _object.computed)('igPosts.[]', 'loadNumber', function () {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      let count = -1000;
      this.igPosts.forEach(item => {
        const pp = item.igPreviewPost();
        pp.set('originalQueueOrder', count);
        pp.set('queueOrder', count);
        previewPosts.pushObject(pp);
        count--;
      });
      return previewPosts;
    }),
    previewPosts: (0, _object.computed)('igPostPreviewPosts.[]', 'existingPreviewPosts.@each.queueOrder', 'newPreviewPosts.@each.queueOrder', function () {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      previewPosts.pushObjects(this.igPostPreviewPosts);
      previewPosts.pushObjects(this.existingPreviewPosts);
      const newToRemove = [];
      const self = this;
      this.newPreviewPosts.forEach(item => {
        const alreadyAPost = self.get('activePosts').find(post => post.get('mediaItem.id') === item.get('mediaItem.id') && post.get('scheduledTime') === item.get('scheduledTime'));
        if ((0, _utils.isNone)(alreadyAPost)) {
          previewPosts.pushObject(item);
        } else {
          newToRemove.push(item);
        }
      });
      this.newPreviewPosts.removeObjects(newToRemove);
      return previewPosts;
    }),
    numNewPosts: (0, _object.computed)('sortedEditablePosts.@each.{isIgPost,isRemoved,scheduledTime}', 'sortedEditablePosts.length', function () {
      let numNewPosts = 0;
      this.sortedEditablePosts.forEach(item => {
        if (item.get('isIgPost')) {
          // noop
        } else if (item.get('isRemoved')) {
          numNewPosts--;
        } else if ((0, _utils.isNone)(item.get('scheduledTime'))) {
          numNewPosts++;
        }
      });
      return numNewPosts;
    }),
    numOverPostLimit: (0, _object.computed)('numNewPosts', 'socialProfile.{hasUnlimitedPosts,postsLeft}', function () {
      if (this.get('socialProfile.hasUnlimitedPosts')) {
        return false;
      }
      if (this.numNewPosts >= this.get('socialProfile.postsLeft')) {
        return this.numNewPosts - this.get('socialProfile.postsLeft');
      }
      return false;
    }),
    canSave: (0, _object.computed)('numOverPostLimit', 'isSaving', function () {
      return this.numOverPostLimit <= 0 && !this.isSaving;
    }),
    shouldShowUpgradeModal: (0, _object.computed)('showSharePlanUpgradeModal', 'auth.currentAccount.canSharePlan', function () {
      return this.showSharePlanUpgradeModal && !this.auth.currentAccount.canSharePlan;
    }),
    actions: {
      showQuickScheduleWizard() {
        this.schedule.isQuickScheduleWizardVisible = true;
      },
      droppedElements(droppedItemIds) {
        const mediaItemIds = droppedItemIds?.split(',').filter(id => id);
        if (!mediaItemIds || (0, _utils.isEmpty)(mediaItemIds)) {
          return;
        }
        this.addNewPreviewPosts({
          mediaItemIds,
          fromQuickSchedule: false
        });
        this.clearSelection();
      },
      revertChanges() {
        this.newPreviewPosts.clear();
        this.previewPosts.forEach(item => {
          item.reset();
        });
        this.incrementProperty('loadNumber');
      },
      saveChanges() {
        if (!this.canSave) {
          return;
        }
        const self = this;
        let postsRescheduled = 0;
        let postsRemoved = 0;
        const currentlyScheduled = new _trackedBuiltIns.TrackedArray();
        const newPosts = new _trackedBuiltIns.TrackedArray();
        const removedPosts = new _trackedBuiltIns.TrackedArray();
        _nprogress.default.start();
        self.set('isSaving', true);
        const toRemove = new _trackedBuiltIns.TrackedArray([]);
        this.sortedEditablePosts.forEach(item => {
          if (item.get('isIgPost')) {
            (0, _debug.debug)('++ should not be here ++');
            return;
          }
          if (item.get('isRemoved')) {
            postsRemoved++;
          } else if (item.get('isCurrentlyScheduled') && item.get('hasUpdatedScheduledTime')) {
            postsRescheduled++;
          }
          if (item.get('isRemoved')) {
            removedPosts.pushObject(item.get('gram.id'));
            toRemove.pushObject(item);
          } else if ((0, _utils.isNone)(item.get('scheduledTime'))) {
            newPosts.pushObject(item.get('autoSchedulingId'));
          } else {
            const a = [item.get('autoSchedulingId'), item.get('scheduledTime')];
            currentlyScheduled.pushObject(a);
          }
        });
        const body = {
          scheduled: currentlyScheduled,
          auto_schedule: newPosts,
          remove: removedPosts
        };
        this.socialProfile.previewGrid(body).then(response => {
          toRemove.forEach(item => {
            if (!item.get('gram.isDeleted') && item.get('gram.isDestroyed') === false && !item.get('gram.isEmpty')) {
              item.gram.set('active', false);
              item.gram.deleteRecord();
            }
          });
          self.get('newPreviewPosts').clear();
          self.store.pushPayload(response);
          self.incrementProperty('loadNumber');
          _nprogress.default.done();
          self.set('isSaving', false);
          self.segment.track('updated-preview', {
            profile: self.get('socialProfile.nickname'),
            posts_rescheduled: postsRescheduled,
            posts_created: newPosts.get('length'),
            posts_removed: postsRemoved
          });
          let numPostsLimit = self.get('extraDisplayedScheduledPosts');
          numPostsLimit = numPostsLimit + newPosts.get('length');
          numPostsLimit = numPostsLimit - postsRemoved;
          self.set('extraDisplayedScheduledPosts', numPostsLimit);
          self.send('reloadRoute');
        }, error => {
          const {
            errors
          } = error;
          _nprogress.default.done();
          self.set('isSaving', false);
          errors.forEach(error => {
            self.errors.show(error.detail);
          });
        });
      },
      removeNewPreviewPost(previewPost) {
        this.newPreviewPosts.removeObject(previewPost);
      }
    },
    makeSharePlan: (0, _emberConcurrency.task)(function* () {
      if (!this.auth.currentAccount.canSharePlan) {
        this.segment.track('clicked-share-calendar-intent', {
          location: 'preview grid'
        });
        if (this.subscriptions.isMobileSubscription) {
          this.subscriptions.openMobileRedirectModal('shareCalendar');
        } else {
          this.set('showSharePlanUpgradeModal', true);
        }
      } else {
        const runMakeSharePlan = async () => {
          await this._makeSharePlan.perform();
        };
        try {
          yield (0, _retry.default)(runMakeSharePlan);
        } catch (error) {
          (0, _object.set)(this, 'hasSharePlanError', true);
        }
      }
    }),
    _makeSharePlan: (0, _emberConcurrency.task)(function* () {
      const sharePlan = this.store.createRecord('share-plan', {
        socialProfileId: this.socialProfile.id
      });
      this.set('sharePlan', sharePlan);
      try {
        yield sharePlan.save();
        this.segment.track('shared-instagram-plan', {
          social_profile_handle: this.socialProfile.get('nickname'),
          share_url: sharePlan.get('planUrl')
        });
      } catch (error) {
        this.errors.log('Make Share Plan failed to create URL', error);
        throw error;
      }
    }),
    addNewPreviewPosts(_ref) {
      let {
        mediaItemIds,
        fromQuickSchedule
      } = _ref;
      if (!this.enableAutoSchedule) {
        return;
      }
      const {
        maxQueueOrder
      } = this;
      let count = maxQueueOrder + 1;
      const newPosts = new _trackedBuiltIns.TrackedArray([]);
      const mediaTypeCount = {
        images: 0,
        videos: 0
      };
      mediaItemIds.forEach(mediaItemId => {
        const mediaItem = this.store.peekRecord('media-item', mediaItemId);
        if (!(0, _utils.isNone)(mediaItem)) {
          const previewPost = mediaItem.igPreviewPost(this.get('socialProfile'));
          previewPost.set('originalQueueOrder', count);
          previewPost.set('queueOrder', count);
          newPosts.pushObject(previewPost);
          mediaItem.mediaType === 'image' ? mediaTypeCount.images++ : mediaTypeCount.videos++;
          count = count + 1;
        }
      });
      if (newPosts[0].mediaItem.get('isGif')) {
        this.alerts.warning(this.intl.t('alerts.preview_grid.gif.message'), {
          title: this.intl.t('alerts.preview_grid.gif.title')
        });
      } else {
        this.segment.track('started-scheduling-post', {
          area: fromQuickSchedule ? 'dragged_from_side_library_to_quick_schedule_visual_planner' : 'dragged_from_side_library_to_visual_planner',
          type: newPosts.firstObject.mediaItem.mediaType,
          is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
          multi_profile_types: this.socialProfilesSelectedForScheduling,
          number_of_images: mediaTypeCount.images,
          number_of_videos: mediaTypeCount.videos
        });
        this.get('newPreviewPosts').pushObjects(newPosts);
      }
      this.schedule.canSchedule(this.socialProfile, {
        numPosts: this.numNewPosts
      });
    },
    clearSelection() {
      this.selectedAssets.clear();
    },
    reset() {
      this.set('igUser', null);
      this.set('igPosts', new _trackedBuiltIns.TrackedArray([]));
      this.set('newPreviewPosts', new _trackedBuiltIns.TrackedArray([]));
      this.incrementProperty('loadNumber');
    }
  });
});